import { render, staticRenderFns } from "./DeactivateFeedback.vue?vue&type=template&id=082fa33d&"
import script from "./DeactivateFeedback.vue?vue&type=script&lang=js&"
export * from "./DeactivateFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports